// Generated by tools/sync-version.mjs. Do not edit manually.
export const OCTADIAM_WEB_VERSION = "33";
export const OCTADIAM_WEB_FULL_VERSION = "33.0.2";
